import { ArrowRightButton } from "@/components/index-v2/arrow-button";
import Link from "next/link";
import AboutArrow from "../../../public/img/cheersup-v2/about-arrow.svg";
import Image from "next/image";
import classNames from "classnames";
import { RoadmapModal } from "../roadmap-modal";
import { useState } from "react";

function noop() {}

const Item = ({ children, className = "", onClick = noop }) => {
  return (
    <div
      className={classNames(
        "relative inline-block rounded-[40px] overflow-hidden bg-black group cursor-pointer",
        className
      )}
      onClick={onClick}
    >
      <div>{children}</div>

      <AboutArrow className="absolute right-0 top-0 transition translate-x-[100%] opacity-0 group-hover:opacity-100 group-hover:translate-x-0" />
    </div>
  );
};

export const Discover = () => {
  const [roadmapModalVisible, setRoadmapModalVisible] = useState(false);

  return (
    <div className="bg-white text-black py-[60px]">
      <div className="flex items-center container mx-auto 2xl:w-[1440px]">
        <div className="w-[30%] mr-[40px]">
          <div className="text-[60px] font-bold font-DIN_Alternate mb-[24px]">
            DISCOVER
            <br />
            MORE
          </div>

          <Link href="/cheersup" className="inline-block">
            <ArrowRightButton>
              <div className="relative">BACK</div>
            </ArrowRightButton>
          </Link>
        </div>

        <div className="flex-1 flex">
          <Item
            className="flex-1 mr-[8px]"
            onClick={() => {
              setRoadmapModalVisible(true);
            }}
          >
            <img
              className="w-full align-top"
              src="/img/cheersup-v2/about-roadmap.png"
              alt=""
            />
          </Item>

          <Link href="/nft-auth" target="_blank" className="w-1/2">
            <Item>
              <img
                className="w-full align-top"
                src="/img/cheersup-v2/about-auth.png"
                alt=""
              />
            </Item>
          </Link>
        </div>
      </div>

      {roadmapModalVisible && (
        <RoadmapModal
          onBack={() => {
            setRoadmapModalVisible(false);
          }}
        />
      )}
    </div>
  );
};
